"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommonLogin = void 0;
var _react = _interopRequireDefault(require("react"));
require("./styles.scss");
var _loginForm = require("../../schoolUiComponents/loginForm");
var _state = require("../state");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var CommonLogin = function CommonLogin(_ref) {
  var _ref$isParent = _ref.isParent,
    isParent = _ref$isParent === void 0 ? false : _ref$isParent;
  var _useAuthSigninState = (0, _state.useAuthSigninState)(),
    sendEvent = _useAuthSigninState.sendEvent;
  var label = isParent ? "Parents" : "Teacher";
  var url = isParent ? "/parents/register" : "/teachers/register";
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "username-login",
    "data-sentry-component": "CommonLogin",
    "data-sentry-source-file": "index.tsx"
  }, /*#__PURE__*/_react["default"].createElement("h4", null, label, " Login"), /*#__PURE__*/_react["default"].createElement(_loginForm.LoginForm, {
    primaryInputLabel: "Username / Email",
    source: "".concat(label, " Login"),
    sendEvent: sendEvent,
    "data-sentry-element": "LoginForm",
    "data-sentry-source-file": "index.tsx"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "register-link"
  }, "New ", label, " ?", /*#__PURE__*/_react["default"].createElement("a", {
    href: url,
    onClick: function onClick() {
      return sendEvent("Register here: ".concat(url));
    }
  }, "Register here")));
};
exports.CommonLogin = CommonLogin;